import React from 'react';
import { Button, Modal } from 'antd';
import s from './s.module.less';
import Star from '../../images/star.svg';

type Props = {
    show: boolean;
    onClose: () => void;
    onUpload?: () => void;
};

const UploadReviewsModal = (props: Props) => {
    const { show, onClose, onUpload } = props;

    const handleLater = () => {
        onClose();
    };

    const handleUpload = () => {
        onClose();
        if (onUpload) {
            onUpload();
        }
    };

    return (
        <Modal
            open={show}
            width={528}
            closable={false}
            footer={null}
            className={s.uploadReviewsModal}
            onCancel={onClose}
        >
            <div className={s.uploadReviewsModalContent}>
                <div className={s.uploadReviewsModalHeader}>
                    <div className={s.uploadReviewsModalImage}>
                        <img src={Star} alt="star" />
                    </div>
                    <div
                        className={s.uploadReviewsModalClose}
                        onClick={onClose}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M18 6L6 18M6 6L18 18" stroke="#9CA3AF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </div>
                </div>
                <div className={s.uploadReviewsModalBody}>
                    <h2 className={s.uploadReviewsModalTitle}>Got reviews? Bring them to Klarity!</h2>
                    <p className={s.uploadReviewsModalDescription}>
                        Just joined Klarity? You can upload up to <strong>50 reviews from your existing patients within 30 days</strong>. They&apos;ll show up as anonymous (not verified), but they still give new patients a reason to choose you. Start building your reputation today!
                    </p>
                </div>
                <div className={s.uploadReviewsModalFooter}>
                    <Button
                        className={s.uploadReviewsModalBtnLater}
                        onClick={handleLater}
                    >
                        Do it later
                    </Button>
                    <Button
                        type="primary"
                        className={s.uploadReviewsModalBtnUpload}
                        onClick={handleUpload}
                    >
                        Upload now
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export default UploadReviewsModal;

